import { MergedStation } from './../../shared/model/merged-station.interface';
import { StationSource } from './../models/station-source';
import { Cacheable } from 'ngx-cacheable';
import { Injectable } from '@angular/core';
import { Observable, Subscriber, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PPStation, Station } from '../models';
import { RemoteApiService } from './remote-api.service';
import { chain } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class StationService {

  private stationCache: Map<String, Station>;
  private ppStationCache: Map<String, PPStation>;

  constructor(private remoteApi: RemoteApiService) {
    this.stationCache = new Map();
    this.ppStationCache = new Map();
  }

  findAllStations(): Observable<Station[]> {
    return this.remoteApi.getStation<Station[]>(`/station`);
  }

  @Cacheable({
    async: true,
    maxCacheCount: 5
  })
  findStation(stationsId: string): Observable<Station> {
    const parameters: any = {
      offset: 0,
      limit: 10,
      sortKey: 'market',
      sortOrder: 'asc'
    };

    if (stationsId != null) {
      parameters.stationIds = stationsId.toString().split((/\s*,\s*/));
    }

    return this.remoteApi
      .getStation<Station[]>(`/station/search`, parameters)
      .pipe(
        map((resp) => {
          return resp.length > 0 ? resp[0] : null;
        })
      );
  }

  @Cacheable({
    async: true,
    maxCacheCount: 5
  })
  findStationsByCriteria(stationsId: String[], formats: string[], markets: string[],
    pageNumber: number = 0, pageSize: number = 10, sortKey = 'market', sortOrder = 'asc',): Observable<Station[]> {
    const parameters: any = {
      offset: pageNumber * pageSize,
      limit: pageSize
    };

    if (stationsId != null && stationsId.length > 0) {
      if (stationsId.length == 1) {
        parameters.stationIds = stationsId.toString().split((/\s*,\s*/));
      } else {
        parameters.stationIds = stationsId;
      }
    }

    if (formats != null && formats.length > 0) {
      parameters.formats = formats;
    }

    if (markets != null && markets.length > 0) {
      parameters.markets = markets;
    }

    if (sortKey) {
      parameters.sortKey = sortKey;
    }

    if (sortOrder) {
      parameters.sortOrder = sortOrder;
    }

    return this.remoteApi.getStation<Station[]>(`/station/search`, parameters);
  }


  groupStationByName(list: Station[]): MergedStation[] {
    return (
      chain(list)
        .groupBy('name')
        .map((value: Station[], key: string) => {
          const station = value[0];

          let name = station.name;
          const mapStationSources = new Map<number, string>();
          const callLetters = station.callLetters;
          const format = station.format;
          const frequency = station.frequency;
          const market = station.market;
          const timeZone = station.timeZone;

          for (let i = 0; i < value.length; i++) {
            if (value[i].stationSource) {
              mapStationSources.set(value[i].stationSource.id, value[i].id);
            }
          }

          return {
            id: value.map((v) => v.id),
            model: value,
            name,
            callLetters,
            format,
            frequency,
            market,
            timeZone,
            logoUrl: station.stationLogoUrl,
            band: station.band,
            favorite: station.favorite,
            stationSources: value.map((v) => v.stationSource),
            mapStationSources,
          };
        }).value()
    );
  }


  stationSourceList(): Observable<StationSource[]> {
    return this.remoteApi.getStation<StationSource[]>('/station-sources');
  }


}
